import { Component } from 'opus-angular-seed-core';

// Certificate Expiring specific detail form.
// Renders everything below the Trigger/Action selectors for CERTIFICATE_EXPIRING trigger.
@Component({
    bindings: {
        form: '=',            // parent form object (with model, errors)
        activetype: '=',      // currently active moduleType
        enums: '<',           // { COMPANY_LANGUAGE_ENUM, OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM }
        defaultLanguage: '<', // company's default language
        helpers: '<',         // parent helper methods (preview, getVariables, etc.)
        ckconfig: '<'         // CKEditor config
    },
    template: `
        <div>
            <!-- CERTIFICATE_EXPIRING does not show training type tabs (action is not SEND_INDIVIDUAL_NOTIFICATIONS) -->

            <div ng-repeat="(index, template) in vm.form.model.templates"
                 ng-if="vm.activetype==template.moduleType && vm.helpers.isModuleEnabled(template.moduleType)">

                <!-- Enabled toggle row is not shown for CERTIFICATE_EXPIRING (kept implicit) -->

                <!-- iCal is not available for CERTIFICATE_EXPIRING -->

                <div class="alert alert-plain">
                    <p>{{ 'events.Notification text, that will be sent to employee as an e-mail.' | translate }}</p>
                    <ul>
                        <li ng-repeat="item in vm.helpers.getVariables(template)">{{ vm.helpers.getTag(item) }}</li>
                    </ul>
                </div>

                <div class="row">
                    <label class="label">{{ 'events.Recipient' | translate }}</label>
                    <div class="items">
                        <ul class="checkboxes">
                            <li>
                                <label>
                                    <input type="radio" ng-model="template.recipient" value="RELATED_EMPLOYEE" name="recipient-{{$index}}">
                                    <span>{{ 'events.Related user' | translate }}</span>
                                </label>
                            </li>
                            <li>
                                <label>
                                    <input type="radio" ng-model="template.recipient" value="RELATED_EMPLOYEE_DIRECT_MANAGER" name="recipient-{{$index}}">
                                    <span>{{ 'events.Related users direct manager' | translate }}</span>
                                </label>
                            </li>
                            <li>
                                <label>
                                    <input type="radio" ng-model="template.recipient" value="CUSTOM_EMAIL" name="recipient-{{$index}}">
                                    <span>{{ 'events.Custom email' | translate }}</span>
                                </label>
                            </li>
                        </ul>
                        <div class="mt10" ng-if="template.recipient==='CUSTOM_EMAIL'">
                            <label class="label small">{{ 'events.Email recipients' | translate }}</label>
                            <tags-input
                              ng-model="template.customEmails"
                              placeholder="{{ 'events.Add email' | translate }}"
                              max-tags="5"
                              add-on-enter="true"
                              add-on-comma="true"
                              add-on-space="true"
                              add-on-blur="true"
                              add-on-paste="true"
                              paste-split-pattern=",|;|\\s+"
                              replace-spaces-with-dashes="false"
                              allowed-tags-pattern="^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$">
                            </tags-input>
                            <div class="hint">{{ 'events.Up to 5 recipients can be configured' | translate }}</div>
                        </div>
                    </div>
                </div>

                <form-row>
                    <label class="label">{{ 'events.Reminder send time' | translate }}</label>
                    <div class="items">
                        <table class="dnd">
                            <colgroup>
                                <col width="99%"/>
                                <col width="1%"/>
                            </colgroup>
                            <tbody>
                            <tr ng-repeat="(i, item) in template.times">
                                <td>
                                    <input type="number"
                                           min="0"
                                           step="1"
                                           class="form-control small02"
                                           ng-model="item.interval"
                                           ng-model-options="{ allowInvalid: true }"
                                           ng-change="vm.helpers.onIntervalChange(item)"
                                           ng-keydown="vm.helpers.preventNonNumeric($event)">
                                    <select ng-model="item.intervalType"
                                            ng-focus="vm.remindertime=true"
                                            class="form-control small02"
                                            ng-change="vm.helpers.clampReminder(item)">
                                        <option value="DAY">{{ vm.enums.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.DAY }}</option>
                                        <option value="WEEK">{{ vm.enums.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.WEEK }}</option>
                                        <option value="MONTH">{{ vm.enums.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.MONTH }}</option>
                                    </select>
                                    <select ng-model="item.type" ng-focus="vm.remindertime=true" class="form-control small">
                                        <option value="BEFORE_CERTIFICATE_EXPIRATION">{{ 'events.Before certification expiration' | translate }}</option>
                                        <option value="AFTER_CERTIFICATE_EXPIRATION">{{ 'events.After certification expiration' | translate }}</option>
                                    </select>
                                    <a ng-if="i!==0" ng-click="vm.helpers.deleteTime(i, template.times)" class="btn delete">{{ 'general.Delete' | translate }}</a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <a class="btn main small" ng-click="vm.helpers.addNewTime(template.times)">{{ 'events.Add new time' | translate }}</a>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>

                <div class="block02" ng-class="{ open: templateI18n.status === 'ACTIVE' }" ng-repeat="templateI18n in vm.helpers.getSortedLanguages(template.templateI18ns)">
                    <div class="heading01 heading01b">
                        <label class="switch01">
                            <input type="checkbox"
                                   ng-checked="templateI18n.status === 'ACTIVE'"
                                   ng-click="vm.helpers.changeStatus(templateI18n)"
                                   name="switch"
                                   ng-disabled="templateI18n.language === vm.defaultLanguage || vm.isLanguageToggleDisabled(template, templateI18n)"
                            >
                            <span>Yes</span>
                        </label>
                        <h2 class="h3">{{ vm.enums.COMPANY_LANGUAGE_ENUM.LABELS[templateI18n.language] }}</h2>

                        <ul class="actions01">
                            <li>
                                <a class="btn view" ng-click="vm.helpers.preview(templateI18n)">
                                    {{ 'notification.Preview e-mail' | translate }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <form-wrapper>
                        <form-row error="vm.form.errors.templates[index].templateI18ns[templateI18n.language].msgSubject" ng-if="templateI18n.status === 'ACTIVE'">
                            <label class="label">{{ 'notification.E-mail subject' | translate }}*</label>
                            <div class="items">
                                <input ng-model="templateI18n.msgSubject" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.templates[index].templateI18ns[templateI18n.language].msgBody" ng-if="templateI18n.status === 'ACTIVE'" class="form">
                            <label class="label">{{ 'events.Reminder notification' | translate }} *</label>
                            <div class="items">
                                <ng-ckeditor class="mt10" ng-model="templateI18n.msgBody" ng-config="vm.ckconfig"></ng-ckeditor>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                    </form-wrapper>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($scope) {
        'ngInject';
        this.$scope = $scope;
    }

    $onInit () {
        // Watch each template's recipient property
        this.$scope.$watch(() => {
            if (this.form && this.form.model && this.form.model.templates) {
                return this.form.model.templates.map(t => t.recipient);
            }
            return [];
        }, () => {
            if (!this.form || !this.form.model || !this.form.model.templates) {
                return;
            }

            this.form.model.templates.forEach((template) => {
                if (template.recipient === 'CUSTOM_EMAIL') {
                    this.handleRecipientChangeToCustomEmail(template);
                }
            });
        }, true);
    }

    /**
     * When recipient is set to CUSTOM_EMAIL, disable all non-default language templates.
     *
     * @param {Object} template - The template object
     */
    handleRecipientChangeToCustomEmail (template) {
        if (!template.templateI18ns) {
            return;
        }

        // Iterate through all language templates
        Object.keys(template.templateI18ns).forEach(lang => {
            const templateI18n = template.templateI18ns[lang];
            // Disable non-default languages
            if (templateI18n.language !== this.defaultLanguage && templateI18n.status === 'ACTIVE') {
                templateI18n.status = 'INACTIVE';
            }
        });
    }

    /**
     * Determine if a language toggle should be disabled.
     * When recipient is "CUSTOM_EMAIL", only company default language can be used,
     * so all other language toggles should be disabled.
     *
     * @param {Object} template - The template object
     * @param {Object} templateI18n - The template i18n object
     * @returns {boolean} - True if the toggle should be disabled
     */
    isLanguageToggleDisabled (template, templateI18n) {
        // If recipient is "CUSTOM_EMAIL" and this is not the default language, disable the toggle
        if (template.recipient === 'CUSTOM_EMAIL' && templateI18n.language !== this.defaultLanguage) {
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/events/partials/detail/certExpire/index.js